export default __webpack_public_path__ + "static/media/markAttendanceWhite.220f1b66.svg";